import { render, staticRenderFns } from "./RowBlockBuyingInsuranceAutolawyer.vue?vue&type=template&id=28a6f6a6&"
import script from "./RowBlockBuyingInsuranceAutolawyer.vue?vue&type=script&lang=js&"
export * from "./RowBlockBuyingInsuranceAutolawyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports